var pug = require("!../../../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (ngRequired, required) {pug_mixins["centered-content"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cdiv" + (pug.attrs(pug.merge([{"class": "centered-content","layout": "row"},attributes]), true)) + "\u003E\u003Cdiv class=\"content\" layout=\"column\" layout-align=\"start stretch\" flex flex-md=\"90\" flex-lg=\"80\" flex-gt-lg=\"70\" flex-offset-md=\"5\" flex-offset-lg=\"10\" flex-offset-gt-lg=\"15\"\u003E";
block && block();
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
};
pug_mixins["contentful-component"] = pug_interp = function(component){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cdiv" + (pug.attr("ng-if", "" + component + ".fields.type === 'wide'", true, true)) + "\u003E\u003Cicon-panel" + (" class=\"wide-panel\""+pug.attr("panel", "" + component, true, true)) + "\u003E\u003C\u002Ficon-panel\u003E\u003C\u002Fdiv\u003E";
pug_mixins["centered-content"].call({
block: function(){
pug_html = pug_html + "\u003Cicon-panel" + (" class=\"standard-panel\""+pug.attr("panel", "" + component, true, true)) + "\u003E\u003C\u002Ficon-panel\u003E";
},
attributes: {"ng-if": pug.escape("" + component + ".fields.type !== 'wide'")}
});
};





























pug_mixins["required-radio-container"] = pug_interp = function(name, model, layout){
var block = (this && this.block), attributes = (this && this.attributes) || {};
ngRequired = attributes['ng-required']
required = !ngRequired
layout = layout || 'row'
pug_html = pug_html + "\u003Cmd-radio-group" + (pug.attr("ng-required", ngRequired, true, true)+pug.attr("ng-model", model, true, true)+pug.attr("layout", layout, true, true)+pug.attr("ng-class", "'" + name + "'", true, true)) + "\u003E";
block && block();
pug_html = pug_html + "\u003Chelp-mate" + (pug.attr("topic", name, true, true)) + "\u003E\u003C\u002Fhelp-mate\u003E\u003C\u002Fmd-radio-group\u003E\u003Cinput-container class=\"hidden-input\"\u003E\u003Cinput" + (pug.attr("ng-required", ngRequired, true, true)+pug.attr("required", required, true, true)+pug.attr("name", name, true, true)+pug.attr("ng-model", model, true, true)+" ng-show=\"false\" aria-label=\"require\"") + "\u003E\u003C\u002Finput-container\u003E";
};








pug_mixins["required-select"] = pug_interp = function(name, model, label){
var block = (this && this.block), attributes = (this && this.attributes) || {};
label = label || name
pug_html = pug_html + "\u003Cinput-container" + (pug.attr("label", label, true, true)) + "\u003E\u003Cmd-select" + (" class=\"required-select big-list\""+pug.attr("ng-model", model, true, true)+pug.attr("ng-class", "'" + name + "'", true, true)+pug.attr("placeholder", label, true, true)+pug.attr("aria-label", label, true, true)) + "\u003E";
block && block();
pug_html = pug_html + "\u003C\u002Fmd-select\u003E\u003Cinput-container class=\"hidden-input\"\u003E\u003Cinput" + (pug.attr("required", true, true, true)+pug.attr("name", name, true, true)+pug.attr("ng-model", model, true, true)+" ng-show=\"false\" aria-label=\"require\"") + "\u003E\u003C\u002Finput-container\u003E\u003C\u002Finput-container\u003E";
};



















































pug_mixins["label-with-help"] = pug_interp = function(text, topic){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cdiv class=\"label-with-help\" layout=\"row\"\u003E\u003Clabel\u003E" + (pug.escape(null == (pug_interp = text) ? "" : pug_interp)) + "\u003Chelp-mate" + (pug.attr("topic", topic, true, true)) + "\u003E\u003C\u002Fhelp-mate\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E";
};



















pug_mixins["rateDisplay"] = pug_interp = function(rate){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + (pug.escape(null == (pug_interp = rate) ? "" : pug_interp)) + "\u003Cimg src=\"\u002Ficons\u002Ficon-percent-pa.svg\" alt=\"percentage pa\"\u003E";
};












pug_mixins["centered-content"].call({
block: function(){
pug_html = pug_html + "\u003Cdiv class=\"md-padding\" ng-cloak\u003E\u003C!-- TODO: This is prolly replaced by the notices section below.--\u003E\u003Calert-list type=\"investors\"\u003E\u003C\u002Falert-list\u003E\u003Cdiv class=\"email-verification\" ng-if=\"!vm.emailVerified\" ng-cloak\u003E\u003Chelp-box\u003E\u003Ch2\u003E\u003Cmd-icon class=\"warning\"\u003Ewarning\u003C\u002Fmd-icon\u003E You have not yet verified your email address\u003C\u002Fh2\u003E\u003Cp\u003EPlease check your email for a verification request - it may be in your \u003Cstrong\u003EJunk\u003C\u002Fstrong\u003E mail folder. You will not be able to invest until your address has been verified.\u003C\u002Fp\u003E\u003Cmd-button class=\"md-raised md-warn ios-rendering-fix\" ng-click=\"vm.resendVerificationEmail()\" aria-label=\"Resend verification email\"\u003EResend Verification Email\u003C\u002Fmd-button\u003E\u003C\u002Fhelp-box\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"wrapper\"\u003E\u003Cdiv class=\"my-investments\"\u003E\u003Cdiv class=\"my-investments-overview-action\"\u003E\u003Cdiv class=\"my-current-investment\"\u003E\u003Cdiv class=\"my-investment-total\"\u003E\u003Ch2\u003EMy investment\u003C\u002Fh2\u003E\u003Cdiv class=\"total-investment\" ng-if=\"vm.investorLoading.loaded\"\u003E{{vm.summary.totals.invested.amount | asCurrency}}\u003C\u002Fdiv\u003E\u003Cdiv class=\"total-investment\" ng-if=\"!vm.investorLoading.loaded\"\u003E \u003Cmd-progress-circular md-mode=\"indeterminate\" md-diameter=\"40\"\u003E\u003C\u002Fmd-progress-circular\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"my-investment-returns\"\u003E\u003Cdiv class=\"panel\"\u003E\u003Cdiv layout=\"row\" layout-align=\"start left\"\u003E";
pug_mixins["label-with-help"]("Total interest earned", "total-interest-earned");
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"interest\"\u003E\u003Cdiv class=\"value\" ng-if=\"vm.investorLoading.loaded\"\u003E{{ vm.summary.totals.interest.amount | asCurrency }}\u003C\u002Fdiv\u003E\u003Cdiv class=\"value\" ng-if=\"!vm.investorLoading.loaded\"\u003E\u003Cmd-progress-circular md-mode=\"indeterminate\" md-diameter=\"30\"\u003E\u003C\u002Fmd-progress-circular\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"action-invest\"\u003E\u003Cmd-button class=\"invest md-raised md-accent\" ng-if=\"vm.products.pooled\" ui-sref=\"investorDashboard.investmentProductParts\"\u003EInvest\u003C\u002Fmd-button\u003E\u003Cmd-button class=\"p2pMarketplace md-raised md-accent\" ng-if=\"vm.products.p2p &amp;&amp; vm.p2p\" ui-sref=\"marketplace\"\u003EP2P Marketplace\u003C\u002Fmd-button\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"my-investments-overview\"\u003E\u003Cdiv class=\"mast\"\u003E\u003Cdiv class=\"heading-overall\"\u003EOverview\u003C\u002Fdiv\u003E\u003Cdiv class=\"heading-column\"\u003E\u003Cdiv class=\"heading\"\u003EEarnings\u003C\u002Fdiv\u003E\u003Cdiv class=\"when\"\u003ERecent\u003Chelp-mate topic=\"recent-interest-earned\"\u003E\u003C\u002Fhelp-mate\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cul ng-if=\"vm.investorLoading.loaded\"\u003E\u003Cli ng-repeat=\"overview in vm.summary.overview\"\u003E\u003Cdiv class=\"investment\" ng-class=\"overview.type\"\u003E\u003Cdiv class=\"label\"\u003E{{ overview.label }}\u003C\u002Fdiv\u003E\u003Cdiv class=\"ratio\" ng-if=\"!overview.ratio\"\u003E&nbsp;\u003C\u002Fdiv\u003E\u003Cdiv class=\"ratio\" ng-if=\"overview.ratio\"\u003E \u003Cproportional-bar quantity=\"vm.calcSize(overview.amount.amount)\" colour=\"overview.ratio.colour\"\u003E\u003C\u002Fproportional-bar\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"amount\"\u003E{{ overview.amount.amount | asCurrency }}\u003C\u002Fdiv\u003E\u003Cdiv class=\"earnings\"\u003E \u003Cspan ng-if=\"overview.periodEarnings\"\u003E{{ overview.periodEarnings.amount | asCurrency }}\u003C\u002Fspan\u003E\u003Cspan ng-if=\"!overview.periodEarnings\"\u003E&nbsp;\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fli\u003E\u003C\u002Ful\u003E\u003Cdiv class=\"overview-loading\" ng-if=\"!vm.investorLoading.loaded\"\u003E\u003Cmd-progress-circular md-mode=\"indeterminate\" md-diameter=\"60\"\u003E\u003C\u002Fmd-progress-circular\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"notices\"\u003E\u003C!--p Notices--\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
}
});}.call(this,"ngRequired" in locals_for_with?locals_for_with.ngRequired:typeof ngRequired!=="undefined"?ngRequired:undefined,"required" in locals_for_with?locals_for_with.required:typeof required!=="undefined"?required:undefined));;return pug_html;};
module.exports = template;